<template>
    <div class="main-container">
        <h3>Payroll Report Logs</h3>
        <div class="type">
          <tl-select
          label = 'Report Type'
          :options="reportType"
          v-model="RepType"
          @change="(val)=>{RepType =val;employeeData=[]}"
          />
          <tl-select
          label = 'Financial Year'
          labelText="name"
          :options="financialYearList"
          v-model="financialYear"
          @change="(val)=>{financialYear =val;}"
          />
          
          <tl-select
          label = 'Month'
          labelText="name"
          :options="monthList"
          v-model="selectedMonth"
          @change="(val)=>{selectedMonth =val;}"
          />
          <btn text="Generate" style="margin-top: 15px;" type="primary" @click="generateReport()" />
        </div>
        <toast-message
          :message="errmsg"
          type="error"
          :isToastEnable="toast"
          @close="(val) => toast = val"
        />
        <div class="table-div" ref="table_div" @scroll="onScroll()">
            <data-table
                :columns="employeeTableColumns"
                :tableData="employeeData"
                :showinrow="true"
                :with-form="false"
                :showedit="false"
                :showhistory="false"
                :showdelete="false"
                @editStart="navigateToIncomeTax"
            >
            <template v-if="RepType !='Payroll Status'" v-slot:rowcontent="slotprops">
            <p class="proxy-container" v-if="slotprops.value.column.key == 'action'">
              <img src="@/assets/download.svg"  class="cross-circle-img"
                @click="editPermission(slotprops.value.record)" alt="actionIcon" style="margin:0px 10px;" />
            </p>
          </template>
            </data-table>
      </div>
        <pop-up-message
          v-if="showErrorPopup"
          :message="showMessage"
          :popupType="popupType"
          :popupHeaderMessage="popupHeaderMessage"
          btnText="OK"
          @back="gotoBack()"
        ></pop-up-message>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
const crypto = require("crypto");
export default {
  data(){
    return{
        financialYear: [],
        RepType:[],
        popupType:"",
        popupHeaderMessage:"",
        selectedMonth:[],
        employeeTableColumns: [
    {
        label: "Report Name",
        key: "RepName"
    },
    {
        label: "User",
        key: "user"
    },
    
    {
        label: "Last Modified On",
        key: "modify_at"
    },
    {
        label: "Action/Status",
        key: "action",
    },
],
      employeeData:[],
      reportType:["Salary Revision Logs","Salary Register","IT Computation","Payroll Status"],
      financialYearList:[],
      monthList:[{name:"January", value:"jan"},{name:"February", value:"feb"},{name:"March", value:"mar"},{name:"April", value:"apr"},{name:"May", value:"may"},{name:"June", value:"jun"},{name:"July", value:"jul"},{name:"August", value:"aug"},{name:"September", value:"sep"},{name:"October", value:"oct"},{name:"November", value:"nov"},{name:"December", value:"dec"}],
      toast:false,
      errmsg:'',
      showErrorPopup: false,
      salaryRevisionData:[],
      salaryRegister:[],
      payrollData:"",
      itComputation:[],
      showMessage: '',
    }
  },
  mounted(){
    this.generateFinancialYear();
  },
  computed: {
    ...mapState({
      entities: state => state.onboard.legal_entities.data
    }),

    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  methods:{
    ...mapActions({
        payrollLogs:
        "dashboard/payroll/reports/Reports/downloadPayrollReportLogs",
    }),

    gotoBack(){
      this.showErrorPopup = false;
    },
    generateFinancialYear() {
      try {
        
        let date = new Date();
        let year =
          date.getMonth() > 2 ? date.getFullYear() : date.getFullYear() - 1;
        for (let i = year; i > year - 5; i--) {
          this.financialYearList.push({
            name: i + "-" + (i + 1),
            value: i + ""
          });
          
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
      editPermission(x) {
          const link = document.createElement('a');
          link.href = x.action;
          link.download = '';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      },
    async generateReport(){
        let obj={
                legalEntityId: this.le_id,
                month: this.selectedMonth.value,
                financialYear: this.financialYear.value,
                }
          this.toast = false;
          this.showLoader = true;
          let res = await this.payrollLogs(obj);
        if (this.RepType == 'Salary Revision Logs') {
            this.toast = false;
            this.employeeData = [];
            this.salaryRevisionData = res.data.payload.salaryRevisionData ;

            if (this.salaryRevisionData!=null) {
                this.employeeData = this.salaryRevisionData.map(item => ({
                    RepName: "Salary Revision",
                    user: item.email.slice(0, 25) + "...",
                    action: item.link,
                    modify_at: item.updated_at
                }));
            }
            else{
                this.showErrorPopup = true;
                this.popupType = 'Warning'
                this.showMessage = "No Data Found";
                this.popupHeaderMessage = "Warning"
            }
        }
          else if(this.RepType=='Salary Register'){
            this.toast = false;
            this.employeeData=[];
            this.salaryRegister = res.data.payload.salaryRegister
            if(this.salaryRegister!=null){
                this.employeeData = this.salaryRegister.map(item => ({
                RepName: "Salary Register",
                user: item.name,
                action: item.link,
                modify_at: item.updated_at
                }));
            }
            else{
                this.showErrorPopup = true;
                this.popupType = 'Warning'
                this.showMessage = "No Data Found";
                this.popupHeaderMessage = "Warning"
            }
            
          }
          else if(this.RepType=='IT Computation'){
            this.toast = false;
            this.employeeData=[];
            this.itComputation = res.data.payload.itComputation;
            if(this.itComputation !== null){
                this.employeeData = this.itComputation.map(item => ({
                RepName: "IT Computation",
                user: item.name,
                action: item.link,
                modify_at: item.updated_at
                }));
            }
            else{
                this.showErrorPopup = true;
                this.popupType = 'Warning'
                this.showMessage = "No Data Found";
                this.popupHeaderMessage = "Warning"
            }
          }
          else if(this.RepType=='Payroll Status'){
            this.toast = false;
            this.employeeData=[];
            this.payrollData = res.data.payload.payrollData;
            if(this.payrollData !== null){
                this.employeeData = this.payrollData.map(item => ({
                RepName: "Payroll Status",
                user: item.email,
                action: item.status,
                modify_at: item.created_at.slice(0,10)
                }));
            }
            else{
                this.showErrorPopup = true;
                this.popupType = 'Warning'
                this.showMessage = "No Data Found";
                this.popupHeaderMessage = "Warning"
            }
          }
    },
    

    
  }
  
}
</script>

<style scoped lang="scss">
.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
  margin-top: 20px;
}
.type {
  display: flex;
  margin-top: 30px;
  div {
    width: 250px;
    padding-right: 20px;
  }
}

  .text {
    font-size: 14px;
    font-weight: 600;
    margin-left: 8px;
    margin-bottom: 10px;
    cursor: pointer;
  }

</style>
